import { createFileRoute } from '@tanstack/react-router'
import { HttpStatusPage, httpStatusHead } from '@/components/http-status-page'
import type { HttpStatusData } from '@/components/http-status-page'

const data: HttpStatusData = {
  code: 302,
  name: 'Found',
  description:
    'The requested resource temporarily resides at a different URL. Unlike 301, this redirect is temporary — browsers and search engines should continue using the original URL for future requests.',
  causes: [
    'The server temporarily redirects users to another page, such as a login page or a maintenance notice.',
    'Load balancers or CDNs redirect requests to a different backend server or region temporarily.',
    'A/B testing or feature flags redirect some users to a different version of a page.',
  ],
  fixes: [
    'If the redirect is intentional and temporary, no fix is needed. Ensure the Location header points to a valid URL.',
    'If the move is permanent, change the status code to 301. Using 302 for permanent moves hurts SEO because search engines won\'t transfer link equity.',
    'Check for redirect loops — a 302 that points back to the original URL or creates a chain will cause browsers to show an ERR_TOO_MANY_REDIRECTS error.',
  ],
  monitoringTip:
    'Uptrack follows 302 redirects and checks the final destination for availability. If the redirect target goes down or a redirect loop forms, Uptrack detects it within 30 seconds and alerts you once several locations confirm it.',
}

export const Route = createFileRoute('/_site/http/302')({
  component: () => <HttpStatusPage data={data} />,
  head: () => httpStatusHead(data),
})
